var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDatefinder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDatefinder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.27,0 L17.2568359,0 L17.2568359,2.8764557 C17.2568359,3.81723629 16.5361328,4.56962025 15.63125,4.56962025 L15.11875,4.56962025 C14.2138672,4.56962025 13.4931641,3.81763713 13.4931641,2.8764557 L13.4931641,0 L7.32714844,0 L7.32714844,2.8764557 C7.32714844,3.81723629 6.59283203,4.56962025 5.68875,4.56962025 L5.17625,4.56962025 C4.27216797,4.56962025 3.5234375,3.81763713 3.5234375,2.8764557 L3.5234375,0 L1.23,0 C0.553339844,0 0,0.591244726 0,1.29512658 L0,17.7201055 C0,18.4239873 0.553339844,19 1.23,19 L19.27,19 C19.9466602,19 20.5,18.4239873 20.5,17.7201055 L20.5,1.29512658 C20.5,0.591244726 19.9466602,0 19.27,0 Z M18.7783203,16.3343882 C18.7767816,16.8318536 18.3743443,17.2347464 17.8774414,17.2362869 L2.62255859,17.2362869 C2.12565568,17.2347464 1.72321844,16.8318536 1.72167969,16.3343882 L1.72167969,7.1149789 C1.72321844,6.61751348 2.12565568,6.21462066 2.62255859,6.21308017 L17.8774414,6.21308017 C18.3743443,6.21462066 18.7767816,6.61751348 18.7783203,7.1149789 L18.7783203,16.3343882 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.789152542,5.5 C0.358644068,5.5 0,5.04850746 0,4.50548507 L0,0.983022388 C0,0.440820896 0.358644068,0 0.789152542,0 L1.22305085,0 C1.65355932,0 2,0.440820896 2,0.983022388 L2,4.50507463 C2,5.04850746 1.65355932,5.5 1.22305085,5.5 L0.789152542,5.5 Z M10.568784,5.5 C10.130853,5.5 9.78947368,5.04850746 9.78947368,4.50507463 L9.78947368,0.98261194 C9.78947368,0.440820896 10.130853,0 10.568784,0 L11.0101633,0 C11.4480944,0 11.7894737,0.440820896 11.7894737,0.98261194 L11.7894737,4.50507463 C11.7894737,5.04850746 11.4480944,5.5 11.0101633,5.5 L10.568784,5.5 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9.5 L7.5,9.5 L7.5,12.625 L4,12.625 L4,9.5 Z M4,13.875 L7.5,13.875 L7.5,17 L4,17 L4,13.875 Z M9.09090909,9.5 L12.5909091,9.5 L12.5909091,12.625 L9.09090909,12.625 L9.09090909,9.5 Z M9.09090909,13.875 L12.5909091,13.875 L12.5909091,17 L9.09090909,17 L9.09090909,13.875 Z M14.5,9.5 L18,9.5 L18,12.625 L14.5,12.625 L14.5,9.5 Z M14.5,13.875 L18,13.875 L18,17 L14.5,17 L14.5,13.875 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-18.000000, -2858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDatefinder",
    transform: "translate(18.000000, 2858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey-copy-2",
    transform: "translate(0.500000, 1.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#646464",
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.500000, -3.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDatefinder);
export default __webpack_public_path__ + "static/media/icDatefinder.4ac5a329b9ed640acae95a65a8610aae.svg";
export { ForwardRef as ReactComponent };